import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { createPaymentLinkPayment } from "app/api/payment";

export default function usePayPaymentLink() {
  const { isLoading, data, mutate, error } = useMutation(createPaymentLinkPayment, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      toast.error(errorMessage);
    },
  });

  return { isLoading, data: data?.data?.data, createPaymentLinkPayment: mutate, error: error ? parseError(error) as string : null };
}
